module.exports = __webpack_public_path__ + "da90ec95538fe9afb2f6ed6e8a642e83.svg";